"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
/** HQ */
exports.smartHQ = {
    initiative: 0,
    melee: [1, 1, 1, 1, 1, 1],
    module: [true, true, true, true, true, true],
    moduleType: types_1.Modules.Move,
    type: types_1.TileTypes.HQ,
    toughness: 20
};
/** Soldiers */
exports.smartRipper = {
    initiative: 2,
    melee: [2, 0, 0, 0, 0, 0],
    name: types_1.SmartSoldierTiles.Ripper,
    toughness: 1,
    type: types_1.TileTypes.Soldier
};
exports.smartTwister = {
    armor: [false, false, false, true, false, false],
    initiative: [2, 1],
    melee: [2, 1, 0, 1, 0, 1],
    name: types_1.SmartSoldierTiles.Twister,
    toughness: 1,
    type: types_1.TileTypes.Soldier
};
exports.smartNetFighter = {
    name: types_1.SmartSoldierTiles.NetFighter,
    net: [true, false, false, false, false, false],
    toughness: 1,
    type: types_1.TileTypes.Soldier
};
exports.smartGaussCannon = {
    initiative: 2,
    name: types_1.SmartSoldierTiles.GaussCannon,
    percing: [1, 0, 0, 0, 0, 0],
    toughness: 1,
    type: types_1.TileTypes.Soldier
};
exports.smartGolemMK3 = {
    initiative: 2,
    name: types_1.SmartSoldierTiles.GolemMK3,
    range: [2, 0, 0, 0, 0, 0],
    toughness: 1,
    type: types_1.TileTypes.Soldier
};
exports.smartCyborg = {
    initiative: 3,
    name: types_1.SmartSoldierTiles.Cyborg,
    range: [1, 0, 0, 0, 0, 0],
    toughness: 1,
    type: types_1.TileTypes.Soldier
};
exports.smartTransporter = {
    armor: [true, false, false, false, false, true],
    mobility: true,
    name: types_1.SmartSoldierTiles.Transporter,
    replace: true,
    toughness: 2,
    type: types_1.TileTypes.Soldier
};
exports.smartBioDroid = {
    flashBack: true,
    initiative: 3,
    name: types_1.SmartSoldierTiles.BioDroid,
    range: [0, 1, 0, 0, 0, 1],
    toughness: 1,
    type: types_1.TileTypes.Soldier
};
/** Modules */
exports.smartOfficer = {
    module: [true, false, false, false, false, false],
    moduleType: types_1.Modules.Officer,
    name: types_1.SmartModuleTiles.Officer,
    type: types_1.TileTypes.Module,
    toughness: 1
};
exports.smartMother = {
    module: [true, false, false, false, false, false],
    moduleType: types_1.Modules.Mother,
    name: types_1.SmartModuleTiles.Mother,
    toughness: 1,
    type: types_1.TileTypes.Module
};
exports.smartScout = {
    module: [true, false, false, false, false, false],
    moduleType: types_1.Modules.Scout,
    name: types_1.SmartModuleTiles.Scout,
    toughness: 1,
    type: types_1.TileTypes.Module
};
